/**
 * API Service Types
 * This file contains TypeScript interfaces and types for the API service
 */

// HTTP Methods supported by the API client
export enum HttpMethod {
  GET = 'GET',
  POST = 'POST',
  PUT = 'PUT',
  DELETE = 'DELETE',
  PATCH = 'PATCH',
}

// Request configuration options
export interface RequestConfig<T = unknown> {
  method: HttpMethod;
  url: string;
  data?: T;
  params?: Record<string, string | number | boolean | undefined>;
  headers?: Record<string, string>;
  timeout?: number;
  withCredentials?: boolean;
  signal?: AbortSignal;
  formData?: boolean;
}

// Standard API response format
export interface ApiResponse<T = unknown> {
  data: T;
  status: number;
  statusText: string;
  headers: Record<string, string>;
}

// Standard error format based on API error response structure
export interface ApiError {
  status: number;
  code: string;
  number?: number;
  message: string;
  timestamp?: string;
  path?: string;
  details?: {
    requestId?: string;
    resourceName?: string;
    fieldName?: string;
    fieldValue?: string;
    fieldErrors?: Record<string, string>;
    requiredRole?: string;
    [key: string]: unknown;
  };
}

// Auth token types
export interface AuthTokens {
  accessToken: string;
  tokenType: string;
}

// API client configuration
export interface ApiClientConfig {
  baseURL: string;
  timeout?: number;
  headers?: Record<string, string>;
}

// Request interceptor function type
export type RequestInterceptor = (config: RequestConfig) => RequestConfig | Promise<RequestConfig>;

// Response interceptor function types
export type ResponseInterceptor = <T>(response: ApiResponse<T>) => ApiResponse<T> | Promise<ApiResponse<T>>;
export type ErrorInterceptor = (error: ApiError) => ApiError | Promise<ApiError> | Promise<ApiResponse>;

// Loading state change handler
export type LoadingStateChangeHandler = (isLoading: boolean, requestId?: string) => void;

// Notification handlers
export type SuccessNotificationHandler = <T>(response: ApiResponse<T>, config: RequestConfig) => void;
export type ErrorNotificationHandler = (error: ApiError, config: RequestConfig) => void;
